import * as React from 'react';

const EloPaymentRebrandingSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 192 128" fill="none" {...props}>
        <g clipPath="url(#elo-payment-rebranding_svg__clip0_101_1030)">
            <path
                d="M0 16C0 7.163 7.163 0 16 0h160c8.837 0 16 7.163 16 16v96c0 8.837-7.163 16-16 16H16c-8.837 0-16-7.163-16-16V16z"
                fill="#fff"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M176 4H16C9.373 4 4 9.373 4 16v96c0 6.627 5.373 12 12 12h160c6.627 0 12-5.373 12-12V16c0-6.627-5.373-12-12-12zM16 0C7.163 0 0 7.163 0 16v96c0 8.837 7.163 16 16 16h160c8.837 0 16-7.163 16-16V16c0-8.837-7.163-16-16-16H16z"
                fill="#E8E8E7"
            />
            <path
                d="M110.197 72.905a.03.03 0 00-.008.009l-.307-.208c-.886 1.437-2.269 2.602-4.012 3.358-3.319 1.443-6.395 1.072-8.604-.865l-.202.31c-.002-.004-.003-.007-.006-.007l-3.766 5.634c.934.65 1.939 1.2 2.992 1.64 4.161 1.728 8.419 1.649 12.612-.176 3.033-1.313 5.413-3.318 7.04-5.859l-5.739-3.836zM98.44 59.003c-3.504 1.506-5.311 4.793-4.94 8.648l14.846-6.389c-2.552-3-5.875-3.994-9.906-2.259zm-9.856 17.164a18.992 18.992 0 01-1.126-2.168c-1.713-3.976-1.795-8.091-.349-12.041 1.59-4.332 4.629-7.649 8.554-9.338 4.934-2.123 10.393-1.705 15.122 1.101 3.006 1.724 5.135 4.385 6.752 8.149.207.482.388.996.565 1.433L88.584 76.167zM128.421 44.32v31.326l4.871 1.975-2.767 6.457-5.375-2.24c-1.207-.522-2.029-1.32-2.65-2.223-.596-.92-1.04-2.183-1.04-3.883V44.321h6.961zM141.036 67.667a8.858 8.858 0 013.045-6.685l-4.997-5.57a16.318 16.318 0 00-5.527 12.247 16.322 16.322 0 005.512 12.264l4.99-5.576a8.868 8.868 0 01-3.023-6.68zM149.913 76.556a8.977 8.977 0 01-2.815-.46l-2.386 7.096c1.631.547 3.378.845 5.193.848 7.912.008 14.518-5.606 16.049-13.068l-7.334-1.498c-.835 4.046-4.417 7.085-8.707 7.082zM149.936 51.308a16.337 16.337 0 00-5.187.836l2.364 7.1a8.883 8.883 0 0111.515 6.664l7.336-1.488c-1.51-7.472-8.111-13.107-16.028-13.112z"
                fill="#231F20"
            />
            <path
                d="M68.308 67.165c-1.466 7.2-7.83 12.61-15.457 12.61-1.75 0-3.436-.282-5.007-.81l-3.503 10.47a26.812 26.812 0 008.51 1.376c12.962 0 23.779-9.198 26.271-21.428l-10.814-2.218z"
                fill="#EF4023"
            />
            <path
                d="M35.086 84.088l7.314-8.27a15.747 15.747 0 01-5.325-11.816c0-4.7 2.058-8.92 5.32-11.808l-7.316-8.27c-5.544 4.912-9.042 12.088-9.042 20.078 0 7.996 3.5 15.173 9.049 20.086z"
                fill="#00A4E0"
            />
            <path
                d="M47.85 49.035a15.76 15.76 0 015.003-.808c7.63 0 14 5.42 15.46 12.624l10.816-2.207C76.645 46.403 65.827 37.19 52.853 37.19c-2.973 0-5.829.484-8.501 1.377l3.498 10.468z"
                fill="#FFCB03"
            />
        </g>
        <defs>
            <clipPath id="elo-payment-rebranding_svg__clip0_101_1030">
                <path fill="#fff" d="M0 0h192v128H0z" />
            </clipPath>
        </defs>
    </svg>
);

EloPaymentRebrandingSvg.displayName = 'EloPaymentRebrandingSvg';
export default EloPaymentRebrandingSvg;
